import { useEffect, useState } from 'react';

const useDebounce = (value?: string, delay?: number) => {
  const [debouncedValue, setDebounced] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounced(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);
  // console.log('inside debounce ==>', { debouncedValue })
  return debouncedValue;
};

export default useDebounce;
